import type { ChargeElements } from '@/types';

export const DEFAULT_ELEMENTS: ChargeElements = {
  murder: [
    'The defendant caused the death of the victim',
    'The defendant acted with deliberate premeditation and malice aforethought',
    'The killing was committed with extreme atrocity or cruelty (first degree) OR with malice aforethought (second degree)'
  ],
  drug: [
    'The defendant knowingly possessed a controlled substance',
    'The defendant knew the substance was a controlled substance',
    'The weight and class of the controlled substance meets the threshold for the charged offense'
  ],
  assault: [
    'The defendant intentionally touched or attempted to touch the victim',
    'The touching was harmful or offensive',
    'The defendant did not have consent or lawful justification'
  ],
  fraud: [
    'The defendant made a false statement of material fact',
    'The defendant knew the statement was false',
    'The defendant made the statement with intent to defraud',
    'The victim relied on the false statement to their detriment'
  ],
  oui: [
    'The defendant operated a motor vehicle',
    'The defendant operated on a public way',
    'At the time of operation, the defendant was under the influence of alcohol or drugs to the extent that their ability to operate was impaired'
  ],
  sexual: [
    'The defendant compelled the victim to submit by force or threat of bodily injury',
    'The defendant had sexual intercourse or unnatural sexual intercourse with the victim',
    'The victim did not consent'
  ]
};
